import React, {useState} from 'react';
import Button from '../button';
import Input from '../input';
import moment from 'moment';

import './index.scss';

const emailsSplit = emails => {
    return emails?.split(',').map(function(item) {
        return item.trim();
    });
};

const emailValidator = emails => {
    const emailRegex = new RegExp(`^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$`)
    let isValid = !!emails?.length;
    emailsSplit(emails)?.forEach(email => {
        if(!emailRegex.test(email.trim())) isValid = false;
    });
    return isValid
};

export function EditRequestsForm({brandEmails, editRequest, onCancel, onRequestSubmit, sendBrandContentFeedbackEmail}) {

    const [formValue, setFormValue] = useState({
        emails: brandEmails,
        editRequest: '',
    });

    function onChangeHandler(e) {
        setFormValue({...formValue, [e.target.name]: e.target.value});
    }

    async function onRequestSubmitHandler() {
        if(!formValue?.editRequest) return;
        await onRequestSubmit(formValue.editRequest, emailsSplit(formValue.emails));
    }

    return (
        <>
            <div className={'edits-form'}>
                <div className={'edits-form__header final-form'}>
                    <div className={'header-title'}>
                        <span>{'Final Feedback'}</span>
                        <span className={'header-info'}>{'(Sent to creator)'}</span>
                    </div>
                    {editRequest &&
                        <div className={'edits-form__request-info'}>
                            <div className={'edits-form__user-email'}>{editRequest.emailAddress}</div>
                            <div className={'edits-form__date'}>{moment(editRequest.createdAt).format("MMM DD YYYY")}</div>
                        </div>
                    }
                </div>
                <div className={'edits-form__body'}>
                    {editRequest ? `${editRequest.message}` :
                        <>
                            <div className={'edits-form__input-wrapper'}>
                                <label className={'edits-form__label'}>
                                    {'Add additional email addresses to get notifications, Separate emails by comma'}
                                </label>
                                <Input className={'edits-form__input edits-form__input-text'}
                                       name={'emails'}
                                       value={formValue.emails}
                                       onChange={onChangeHandler}/>
                            </div>
                            <div className={'edits-form__input-wrapper'}>
                                <label className={'edits-form__label'}>
                                    {'To achieve optimal content results, ensure your edit requests to the creator are clear, practical, and reflect your brand\'s preferences'}
                                </label>
                                <textarea className={'edits-form__text-area edits-form__input-text'}
                                          name={'editRequest'}
                                          value={formValue.editRequest}
                                          onChange={onChangeHandler}/>
                            </div>
                            <div className={'edits-form__buttons-wrapper'}>
                                <Button bigtext ghost notransform bold
                                        onClick={onCancel}>
                                    {'Cancel'}
                                </Button>
                                <Button notransform bigtext bold
                                        disabled={!formValue.editRequest || !emailValidator(formValue.emails)}
                                        onClick={onRequestSubmitHandler}>
                                    {'Submit Final Feedback'}
                                </Button>
                            </div>
                        </>
                    }
                </div>
            </div>
            {editRequest &&
                <div className={'edits-form__submit-info'}>
                    <i className={'fa fa-check-circle edits-form__icon'}></i>
                    <span>Edit Requests submitted. You'll be notified via email once the content is
                    re-submitted for review.</span>
                </div>
            }
        </>
    )
}


// WEBPACK FOOTER //
// ./components/edit_requests_form/index.js